import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const BookCard = ({ book }) => {
  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      data-testid="book-card-item"
      className="group flex flex-col h-full"
    >
      <Link
        to={`/books/${book.id}`}
        data-testid={`book-link-${book.id}`}
        className="relative block overflow-hidden rounded-sm bg-[var(--surface-2)] deckle"
      >
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={book.cover}
            alt={book.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <span className="absolute inset-0 ring-1 ring-inset ring-[var(--gold)]/30" />
        <span className="absolute bottom-4 left-1/2 -translate-x-1/2 translate-y-3 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 rounded-full bg-[var(--bg)]/95 backdrop-blur px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text)] inline-flex items-center gap-1.5">
          View Book <ArrowUpRight className="h-3 w-3" />
        </span>
      </Link>

      <div className="mt-5 flex flex-col flex-1">
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--gold)]">
          {book.year} · {book.author.split("·")[0].split("(")[0]}
        </span>
        <h3 className="mt-2 font-serif text-2xl leading-tight text-[var(--text)]">
          <Link to={`/books/${book.id}`} className="hover:text-[var(--terracotta)] transition-colors duration-300">
            {book.title}
          </Link>
        </h3>
        <p className="mt-1.5 font-sans text-sm text-[var(--text-2)] leading-snug">
          {book.subtitle}
        </p>
      </div>
    </motion.div>
  );
};
